<ion-header>
  <ion-toolbar>
    <ion-title>
      {{"COOKIES.CONFIGURATION_PANEL" |translate}}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div [innerHTML]="cookies"></div>
  <!-- <h6>{{"COOKIES.CONFIGURATION_PANEL" |translate}}</h6> -->
  <h1>{{"SECTIONS.COOKIES_POLICY" | translate}}</h1>
  <app-cookies-configurator></app-cookies-configurator>
</ion-content>

<ion-footer>
  <ion-toolbar>

    <!-- <ion-buttons slot="start">
  
    </ion-buttons> -->

    <ion-buttons slot="end">
      <!-- <ion-button color="secondary" (click)="rejectAll()">
        {{"ACTIONS.REJECT_ALL" | translate}}
      </ion-button> -->

      <ion-button color="primary" (click)="saveAll()">
        {{"COOKIES.ACCEPT" | translate}}
      </ion-button>
      <ion-button color="primary" (click)="saveCookiesSettings()">
        {{"COOKIES.SAVE" | translate}}
      </ion-button>
    </ion-buttons>

  </ion-toolbar>
</ion-footer>